// extracted by mini-css-extract-plugin
module.exports = {"inverseTextHero":"InverseTextHero_inverseTextHero__3m6TM"};